import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { EditStatoIncaricoComponent } from './dialogs/edit/edit.component';
import { StatiIncaricoComponent } from './stati-incarico.component';



@NgModule({
  declarations: [StatiIncaricoComponent,
    EditStatoIncaricoComponent,],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    CustomFormControlsModule,
    ReactiveFormsModule,
    ResourcefulIndexModule,
  ],
  exports: [StatiIncaricoComponent,
    EditStatoIncaricoComponent,]
})
export class StatiIncaricoModule { }
